import { Component, Prop, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import MixinGame from '@/mixins/game'

@Component
export default class StockItem extends mixins(MixinGame) {
  @Prop(String) public title: string
  @Prop(Number) public quantity: number

  public action: string | null = null

  @Watch('quantity')
  public onQuantityChanged (value: number, oldValue: number) {
    this.action = (value > oldValue) ? 'plus' : 'minus'

    setTimeout(() => {
      this.action = null
    }, 1000)
  }
}
